import _ from 'lodash';

import { COMPONENTS } from 'Common/Components/NutritionalHover/constants/constants';
import {
  NutrientsFieldEnum as NutrientFields,
  EditIngredientFieldEnum as EditIngredientFields,
  IngMeasurementsFieldEnum as IngMeasurementFields,
} from 'Common/FieldEnum';
import {
  WEIGHT_UNITS,
  VOLUME_UNITS,
  GRAMS_IN_LBS,
  GRAMS_IN_OZ,
} from './Constants';

export const convertMNU_IngredientToIngredient = (MNU_Ingredient) => {
  const newIngredient = { ...MNU_Ingredient };
  Object.keys(NutrientFields).forEach((key) => {
    if (isNaN(newIngredient[key])) {
      newIngredient[key] = 'N/A';
    }
  });

  return newIngredient;
};

export const convertIngredientToMNU_Ingredient = (ingredient) => {
  return {
    ...ingredient,
  };
};

export const hasUserModified = (original, updated) => {
  const updatedKeys = Object.keys(COMPONENTS).map((key) => {
    return original[key] !== updated[key];
  });

  return updatedKeys.filter(Boolean).length > 0;
};

export const convertToGrams = (weight, unit) => {
  switch (_.toUpper(unit)) {
    case WEIGHT_UNITS.LB:
      return _.multiply(weight, GRAMS_IN_LBS);
    case WEIGHT_UNITS.OZ:
      return _.multiply(weight, GRAMS_IN_OZ);
    default:
      // Default to grams
      return weight;
  }
};

export const convertToCups = (unit) => {
  switch (_.toUpper(unit)) {
    case VOLUME_UNITS['FL OZ']:
      return 0.125;
    case VOLUME_UNITS.TEASPOON:
    case VOLUME_UNITS.TSP:
      return 0.0208333;
    case VOLUME_UNITS.TABLESPOON:
    case VOLUME_UNITS.TBSP:
      return 0.0625;
    case VOLUME_UNITS.PINT:
      return 2;
    case VOLUME_UNITS.QUART:
      return 4;
    case VOLUME_UNITS.GALLON:
      return 16;
    case VOLUME_UNITS.CUP:
    default:
      return 1;
  }
};

export const computeCostPerServing = (costPerGram, weightInGrams) => {
  return _.round(_.multiply(costPerGram, weightInGrams), 4);
};

export const isReadOnly = (ingredientSourcesMap, ingredient) => {
  const ingredientSource = ingredient[EditIngredientFields.SourceDesc];
  return (
    _.get(ingredientSourcesMap, `${ingredientSource}.ReadOnly`, false) ||
    _.get(ingredient, EditIngredientFields.IsReadOnly, false)
  );
};

export const isMeasurementComplete = (measure) => {
  return (
    Boolean(measure[IngMeasurementFields.Amount]) &&
    Boolean(measure[IngMeasurementFields.Measurement]) &&
    Boolean(measure[IngMeasurementFields.Weight]) &&
    Boolean(measure[IngMeasurementFields.BaseMeasure])
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/helpers/ingredient.js